// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__nJ1el","linkDestacado":"MenuLink_linkDestacado__puG8q"};